import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FooterComponent } from './footer.component';
import { SharedService } from './shared.service';
import { Utils } from './utils';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("containerRef") containerRef: ElementRef
  @ViewChild("contactRef") contactRef: ElementRef

  public time = 5
  public get countdown(): number {
    return this.time <= 0 ? 0 : this.time
  }
  private interval: any
  
  public constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private titleService: Title,
    private sharedService: SharedService,
  ) {}
  
  public ngOnInit(): void {
    this.titleService.setTitle("Blauwtand — 404")
    this.interval = setInterval(() => {
      this.time -= 1

      if(this.time <= 0) {
        clearInterval(this.interval)
        this.interval = undefined
        this.navigateTo("home")
      }
    }, 1000)
  }

  public async ngAfterViewInit(): Promise<void> {
    await Utils.timeout()

    window.addEventListener("scroll", (event) => {
      this.scrollFade()
    })
    this.scrollFade()
  }

  private scrollFade() {
    const container = this.containerRef.nativeElement as HTMLElement
      
      if(container && container.getBoundingClientRect().y < window.innerHeight && container.classList.contains("scroll-fade")) {
        container.classList.remove("scroll-fade")
      }
  }

  public navigateTo(menuItem: string, isMobileMenu: boolean = false) {
    if(menuItem) {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = undefined
      }
      const lower = menuItem.toLowerCase()
      if (lower === 'home') {
        this.router.navigate(['/'])
      } else {
        this.router.navigate([`/${lower}`])
      }
    }
  }

  public ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = undefined
    }
  }
}
